import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomVideo from 'designer/component/element/Video'

export const VideoSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomVideo {...props} />
  </DragElementWrapper>
)

export const VideoDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomVideo {...props} />
  </ElementWrapper>
)

export const videoTester = rankWith(1000, scopeEndsWith('video'))
